import React from 'react'

const PrivacyPage = () => {
  return (
    <div className="font-['Inter'] min-h-screen bg-white text-[#0F172A]">
      {/* Header */}
      <header className="w-full flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-white/95 backdrop-blur-xl">
        <div className="flex items-center gap-2">
          <div className="text-2xl font-black tracking-tighter text-[#0F172A]">
            UGC<span className="text-[#1D8BF8]">4you</span>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-4xl font-black mb-8 bg-gradient-to-r from-[#1D8BF8] to-[#7c3aed] bg-clip-text text-transparent">
          Privacy Policy
        </h1>

        <div className="prose max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">1. INLEIDING</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>1.1</strong> UGC4you VOF ("UGC4you", "wij", "ons" of "onze") respecteert uw privacy en is toegewijd aan het beschermen van uw persoonlijke gegevens. Deze privacy policy informeert u over hoe wij omgaan met uw persoonlijke gegevens wanneer u onze website bezoekt op https://ugc4you.nl (het "Platform") en vertelt u over uw privacy rechten en hoe de wet u beschermt.
              </p>

              <p>
                <strong>1.2</strong> Deze privacy policy is van toepassing op alle informatie verzameld via ons Platform, onze diensten, marketing, verkoop en evenementen (gezamenlijk aangeduid als "Diensten").
              </p>

              <p>
                <strong>1.3</strong> <strong>Verwerkingsverantwoordelijke</strong><br />
                UGC4you VOF is de verwerkingsverantwoordelijke voor uw persoonlijke gegevens. Voor vragen over deze privacy policy of uw gegevens kunt u contact opnemen via privacy@ugc4you.nl.
              </p>

              <p>
                <strong>1.4</strong> Deze privacy policy is laatst bijgewerkt op 9 september 2025 en is van kracht per deze datum.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">2. GEGEVENS DIE WIJ VERZAMELEN</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>2.1</strong> <strong>Persoonlijke Identificatiegegevens</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Naam (voor- en achternaam)</li>
                <li>E-mailadres</li>
                <li>Telefoonnummer (optioneel)</li>
                <li>Bedrijfsnaam en KvK-nummer (voor zakelijke accounts)</li>
                <li>Profielfoto (optioneel)</li>
                <li>Portfolio links en sociale media profielen (voor creators)</li>
              </ul>

              <p>
                <strong>2.2</strong> <strong>Financiële Gegevens</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Bankrekeningnummer (voor uitbetalingen aan creators)</li>
                <li>BTW-nummer (indien van toepassing)</li>
                <li>Factuuradres</li>
                <li>Betalingsgeschiedenis en transactiegegevens</li>
                <li>Creditcard/betaalkaart informatie wordt verwerkt via Stripe (wij slaan deze niet op)</li>
              </ul>

              <p>
                <strong>2.3</strong> <strong>Technische Gegevens</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>IP-adres</li>
                <li>Browser type en versie</li>
                <li>Tijdzone instellingen</li>
                <li>Browser plug-in types en versies</li>
                <li>Besturingssysteem en platform</li>
                <li>Apparaat informatie (type, model)</li>
              </ul>

              <p>
                <strong>2.4</strong> <strong>Gebruiksgegevens</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Informatie over hoe u ons Platform gebruikt</li>
                <li>Pagina's die u bezoekt en functies die u gebruikt</li>
                <li>Projecten die u aanmaakt of waarop u reageert</li>
                <li>Communicatie tussen gebruikers via het platform</li>
                <li>Uploaded content (video's, afbeeldingen, documenten)</li>
                <li>Zoekgeschiedenis binnen het platform</li>
              </ul>

              <p>
                <strong>2.5</strong> <strong>Marketing en Communicatie Gegevens</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Uw voorkeuren voor het ontvangen van marketing</li>
                <li>Uw communicatievoorkeuren</li>
                <li>Feedback en enquête antwoorden</li>
                <li>Correspondentie met onze klantenservice</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">3. GOOGLE ANALYTICS EN SEARCH CONSOLE</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>3.1</strong> <strong>Google Analytics</strong><br />
                Wij gebruiken Google Analytics, een webanalyse-service aangeboden door Google LLC ("Google"), om ons te helpen begrijpen hoe bezoekers ons Platform gebruiken. Google Analytics verzamelt informatie zoals:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Hoe vaak gebruikers het Platform bezoeken</li>
                <li>Welke pagina's ze bezoeken</li>
                <li>Welke andere sites ze gebruikten voordat ze naar ons Platform kwamen</li>
                <li>Demografische gegevens (leeftijd, geslacht, interesses)</li>
                <li>Geografische locatie (land, stad)</li>
                <li>Apparaat en browser informatie</li>
                <li>Gebruikersgedrag en interacties</li>
              </ul>

              <p>
                <strong>3.2</strong> <strong>Google Analytics Cookies</strong><br />
                Google Analytics plaatst verschillende cookies op uw apparaat:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>_ga:</strong> Onderscheidt unieke gebruikers (bewaartermijn: 2 jaar)</li>
                <li><strong>_gid:</strong> Onderscheidt unieke gebruikers (bewaartermijn: 24 uur)</li>
                <li><strong>_gat:</strong> Beperkt het aantal verzoeken (bewaartermijn: 1 minuut)</li>
                <li><strong>_ga_&lt;container-id&gt;:</strong> Bewaart sessie status (bewaartermijn: 2 jaar)</li>
              </ul>

              <p>
                <strong>3.3</strong> <strong>IP-Anonimisatie</strong><br />
                Wij hebben IP-anonimisatie geactiveerd in Google Analytics. Dit betekent dat Google uw IP-adres verkort binnen de Europese Unie of andere landen die partij zijn bij de Overeenkomst betreffende de Europese Economische Ruimte voordat het naar de Verenigde Staten wordt verzonden.
              </p>

              <p>
                <strong>3.4</strong> <strong>Google Search Console</strong><br />
                Wij gebruiken Google Search Console om:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Te monitoren hoe ons Platform presteert in Google zoekresultaten</li>
                <li>Te identificeren welke zoektermen gebruikers naar ons Platform leiden</li>
                <li>Technische problemen met indexering te detecteren</li>
                <li>De gebruikerservaring te verbeteren op basis van zoekgedrag</li>
                <li>Sitemap indienen en crawl-fouten te monitoren</li>
              </ul>

              <p>
                <strong>3.5</strong> <strong>Gegevensverwerking door Google</strong><br />
                Google verwerkt de verzamelde gegevens namens ons en zal deze informatie niet gebruiken voor eigen doeleinden. Google kan deze informatie aan derden verschaffen indien Google hiertoe wettelijk wordt verplicht, of voor zover deze derden de informatie namens Google verwerken. Wij hebben hiervoor een verwerkersovereenkomst met Google gesloten.
              </p>

              <p>
                <strong>3.6</strong> <strong>Opt-out Mogelijkheden</strong><br />
                U kunt zich afmelden voor Google Analytics door:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>De Google Analytics Opt-out Browser Add-on te installeren</li>
                <li>Cookies te blokkeren in uw browser instellingen</li>
                <li>JavaScript uit te schakelen in uw browser</li>
                <li>Onze cookie banner te gebruiken om analytische cookies te weigeren</li>
              </ul>

              <p>
                <strong>3.7</strong> <strong>Meer Informatie</strong><br />
                Voor meer informatie over hoe Google uw gegevens verwerkt, raadpleeg:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Google Privacy Policy: https://policies.google.com/privacy</li>
                <li>Google Analytics Terms of Service: https://marketingplatform.google.com/about/analytics/terms/us/</li>
                <li>Hoe Google gegevens gebruikt: https://policies.google.com/technologies/partner-sites</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">4. HOE WIJ UW GEGEVENS GEBRUIKEN</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>4.1</strong> <strong>Rechtsgrondslagen voor Verwerking</strong><br />
                Wij verwerken uw persoonlijke gegevens alleen wanneer:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Contractuele noodzaak:</strong> De verwerking is nodig voor de uitvoering van een overeenkomst</li>
                <li><strong>Wettelijke verplichting:</strong> Wij moeten voldoen aan een wettelijke verplichting</li>
                <li><strong>Gerechtvaardigd belang:</strong> De verwerking is noodzakelijk voor onze gerechtvaardigde belangen</li>
                <li><strong>Toestemming:</strong> U heeft toestemming gegeven voor de verwerking</li>
                <li><strong>Vitaal belang:</strong> De verwerking is nodig om iemands leven te beschermen</li>
              </ul>

              <p>
                <strong>4.2</strong> <strong>Doeleinden van Verwerking</strong><br />
                Wij gebruiken uw gegevens voor:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Het leveren van onze diensten en functionaliteiten</li>
                <li>Account aanmaken en beheren</li>
                <li>Verwerken van betalingen en uitbetalingen</li>
                <li>Communicatie over projecten en diensten</li>
                <li>Klantenservice en ondersteuning</li>
                <li>Verbetering van ons Platform en diensten</li>
                <li>Marketing en promotionele doeleinden (met toestemming)</li>
                <li>Voldoen aan wettelijke verplichtingen</li>
                <li>Voorkomen van fraude en misbruik</li>
                <li>Statistische analyses en rapportages</li>
              </ul>

              <p>
                <strong>4.3</strong> <strong>Geautomatiseerde Besluitvorming</strong><br />
                Wij maken geen gebruik van volledig geautomatiseerde besluitvorming die significante gevolgen voor u heeft. Wel gebruiken wij algoritmes voor:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Het matchen van creators met relevante projecten</li>
                <li>Het berekenen van rankings en scores</li>
                <li>Het personaliseren van content aanbevelingen</li>
                <li>Fraude detectie en risico analyse</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">5. COOKIES EN TRACKING TECHNOLOGIEËN</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>5.1</strong> <strong>Wat zijn Cookies?</strong><br />
                Cookies zijn kleine tekstbestanden die op uw apparaat worden geplaatst wanneer u onze website bezoekt. Ze helpen ons om uw voorkeuren te onthouden en uw ervaring te verbeteren.
              </p>

              <p>
                <strong>5.2</strong> <strong>Types Cookies die Wij Gebruiken</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Essentiële Cookies:</strong> Noodzakelijk voor het functioneren van het Platform</li>
                <li><strong>Functionele Cookies:</strong> Onthouden uw voorkeuren en instellingen</li>
                <li><strong>Analytische Cookies:</strong> Helpen ons begrijpen hoe gebruikers het Platform gebruiken</li>
                <li><strong>Marketing Cookies:</strong> Gebruikt voor gerichte advertenties (alleen met toestemming)</li>
                <li><strong>Sessie Cookies:</strong> Tijdelijke cookies die worden verwijderd na het sluiten van de browser</li>
                <li><strong>Persistente Cookies:</strong> Blijven op uw apparaat voor een bepaalde periode</li>
              </ul>

              <p>
                <strong>5.3</strong> <strong>Specifieke Cookies</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>ugc4you_session:</strong> Sessie authenticatie (essentieel)</li>
                <li><strong>ugc4you_token:</strong> JWT authenticatie token (essentieel)</li>
                <li><strong>ugc4you_preferences:</strong> Gebruikersvoorkeuren (functioneel)</li>
                <li><strong>ugc4you_consent:</strong> Cookie toestemming status (essentieel)</li>
                <li><strong>Google Analytics cookies:</strong> Zie sectie 3.2</li>
              </ul>

              <p>
                <strong>5.4</strong> <strong>Cookie Beheer</strong><br />
                U kunt cookies beheren via:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Onze cookie banner bij eerste bezoek</li>
                <li>Browser instellingen (blokkeren of verwijderen)</li>
                <li>Cookie instellingen in uw account</li>
              </ul>

              <p>
                Let op: Het blokkeren van essentiële cookies kan de functionaliteit van het Platform beperken.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">6. MET WIE DELEN WIJ UW GEGEVENS?</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>6.1</strong> <strong>Interne Toegang</strong><br />
                Binnen UGC4you hebben alleen medewerkers toegang tot uw gegevens die deze nodig hebben voor hun werk, onder strikte geheimhouding.
              </p>

              <p>
                <strong>6.2</strong> <strong>Dienstverleners en Verwerkers</strong><br />
                Wij delen gegevens met zorgvuldig geselecteerde dienstverleners:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Stripe:</strong> Betalingsverwerking en financiële transacties</li>
                <li><strong>Cloudinary:</strong> Opslag en verwerking van media bestanden</li>
                <li><strong>MongoDB Atlas:</strong> Database hosting en beheer</li>
                <li><strong>Google:</strong> Analytics, Search Console, en cloud diensten</li>
                <li><strong>SendGrid/Mailgun:</strong> E-mail verzending en notificaties</li>
                <li><strong>AWS/DigitalOcean:</strong> Server hosting en infrastructuur</li>
                <li><strong>Sentry:</strong> Error tracking en monitoring</li>
              </ul>

              <p>
                <strong>6.3</strong> <strong>Platform Gebruikers</strong><br />
                Bepaalde informatie wordt gedeeld tussen gebruikers voor platformfunctionaliteit:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Publieke profielinformatie tussen creators en brands</li>
                <li>Project details met geselecteerde creators</li>
                <li>Berichten tussen projectpartijen</li>
                <li>Portfolio en werk samples (publiek zichtbaar indien ingesteld)</li>
              </ul>

              <p>
                <strong>6.4</strong> <strong>Wettelijke Verplichtingen</strong><br />
                Wij kunnen gegevens delen wanneer wettelijk verplicht:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Met toezichthouders en overheidsinstanties</li>
                <li>In reactie op gerechtelijke bevelen</li>
                <li>Voor belastingdoeleinden en financiële rapportage</li>
                <li>Bij vermoeden van fraude of illegale activiteiten</li>
              </ul>

              <p>
                <strong>6.5</strong> <strong>Bedrijfsoverdracht</strong><br />
                Bij fusie, overname of verkoop kunnen uw gegevens worden overgedragen aan de nieuwe eigenaar, onder dezelfde privacy bescherming.
              </p>

              <p>
                <strong>6.6</strong> <strong>Geen Verkoop van Gegevens</strong><br />
                Wij verkopen, verhuren of verhandelen NOOIT uw persoonlijke gegevens aan derden voor commerciële doeleinden.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">7. INTERNATIONALE GEGEVENSOVERDRACHT</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>7.1</strong> <strong>Gegevensoverdracht buiten de EER</strong><br />
                Sommige van onze dienstverleners zijn gevestigd buiten de Europese Economische Ruimte (EER). Bij overdracht van gegevens buiten de EER zorgen wij voor passende waarborgen:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>EU-US Data Privacy Framework certificering</li>
                <li>Standard Contractual Clauses (SCC's) goedgekeurd door de EU</li>
                <li>Adequaatheidsbesluiten van de Europese Commissie</li>
                <li>Binding Corporate Rules waar van toepassing</li>
              </ul>

              <p>
                <strong>7.2</strong> <strong>Specifieke Landen</strong><br />
                Uw gegevens kunnen worden verwerkt in:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Verenigde Staten:</strong> Google Analytics, Stripe, Cloudinary</li>
                <li><strong>Ierland:</strong> MongoDB Atlas (EU regio)</li>
                <li><strong>Nederland:</strong> Primaire servers en backups</li>
              </ul>

              <p>
                <strong>7.3</strong> <strong>Uw Rechten bij Internationale Overdracht</strong><br />
                U heeft het recht om:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Informatie te ontvangen over waarborgen</li>
                <li>Kopieën van contractuele waarborgen op te vragen</li>
                <li>Bezwaar te maken tegen bepaalde overdrachten</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">8. GEGEVENSBEVEILIGING</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>8.1</strong> <strong>Technische Maatregelen</strong><br />
                Wij implementeren de volgende technische beveiligingsmaatregelen:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>SSL/TLS encryptie voor alle data transmissie</li>
                <li>Encryptie van gevoelige gegevens in rust (AES-256)</li>
                <li>Gehashte wachtwoorden met bcrypt (salt rounds: 10)</li>
                <li>JWT tokens met korte vervaltijd</li>
                <li>Web Application Firewall (WAF)</li>
                <li>DDoS bescherming</li>
                <li>Regelmatige security audits en penetratietesten</li>
                <li>Intrusion Detection System (IDS)</li>
              </ul>

              <p>
                <strong>8.2</strong> <strong>Organisatorische Maatregelen</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Toegangscontrole op need-to-know basis</li>
                <li>Geheimhoudingsovereenkomsten met medewerkers</li>
                <li>Regelmatige security training</li>
                <li>Incident response procedures</li>
                <li>Data minimalisatie principes</li>
                <li>Regelmatige backups met encryptie</li>
              </ul>

              <p>
                <strong>8.3</strong> <strong>Datalek Protocol</strong><br />
                Bij een datalek:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Melden wij dit binnen 72 uur aan de Autoriteit Persoonsgegevens</li>
                <li>Informeren wij getroffen gebruikers zonder onredelijke vertraging</li>
                <li>Documenteren wij de aard en omvang van het lek</li>
                <li>Nemen wij onmiddellijk maatregelen om verdere schade te voorkomen</li>
                <li>Voeren wij een onderzoek uit naar de oorzaak</li>
              </ul>

              <p>
                <strong>8.4</strong> <strong>Uw Rol in Beveiliging</strong><br />
                Help ons uw account te beveiligen door:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Een sterk, uniek wachtwoord te gebruiken</li>
                <li>Twee-factor authenticatie in te schakelen (wanneer beschikbaar)</li>
                <li>Uw wachtwoord geheim te houden</li>
                <li>Verdachte activiteiten te melden</li>
                <li>Uit te loggen op gedeelde apparaten</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">9. BEWAARTERMIJNEN</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>9.1</strong> <strong>Algemene Principes</strong><br />
                Wij bewaren uw gegevens niet langer dan noodzakelijk voor de doeleinden waarvoor ze verzameld zijn, tenzij een langere bewaartermijn wettelijk vereist is.
              </p>

              <p>
                <strong>9.2</strong> <strong>Specifieke Bewaartermijnen</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Accountgegevens:</strong> Tot 2 jaar na sluiting account</li>
                <li><strong>Projectgegevens:</strong> 7 jaar (fiscale bewaarplicht)</li>
                <li><strong>Financiële transacties:</strong> 7 jaar (wettelijke verplichting)</li>
                <li><strong>Communicatie/berichten:</strong> 3 jaar na laatste activiteit</li>
                <li><strong>Marketing gegevens:</strong> Tot intrekking toestemming</li>
                <li><strong>Technische logs:</strong> Maximaal 1 jaar</li>
                <li><strong>Cookie gegevens:</strong> Zie cookie policy voor specifieke termijnen</li>
                <li><strong>Google Analytics data:</strong> 26 maanden (standaard instelling)</li>
                <li><strong>Backup gegevens:</strong> Maximaal 90 dagen</li>
              </ul>

              <p>
                <strong>9.3</strong> <strong>Verwijdering van Gegevens</strong><br />
                Na afloop van de bewaartermijn worden gegevens:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Permanent verwijderd uit onze systemen</li>
                <li>Geanonimiseerd voor statistische doeleinden</li>
                <li>Veilig vernietigd volgens data sanitization standaarden</li>
              </ul>

              <p>
                <strong>9.4</strong> <strong>Uitzonderingen</strong><br />
                Gegevens kunnen langer bewaard worden bij:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Lopende juridische procedures</li>
                <li>Onopgeloste geschillen</li>
                <li>Wettelijke onderzoeken</li>
                <li>Specifieke wettelijke vereisten</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">10. UW PRIVACY RECHTEN</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>10.1</strong> <strong>Rechten onder de GDPR</strong><br />
                Als EU inwoner heeft u de volgende rechten:
              </p>

              <p>
                <strong>10.2</strong> <strong>Recht op Inzage (Artikel 15 GDPR)</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Bevestiging of wij uw gegevens verwerken</li>
                <li>Toegang tot uw persoonlijke gegevens</li>
                <li>Informatie over verwerkingsdoeleinden</li>
                <li>Categorieën van gegevens die verwerkt worden</li>
                <li>Ontvangers van uw gegevens</li>
              </ul>

              <p>
                <strong>10.3</strong> <strong>Recht op Rectificatie (Artikel 16 GDPR)</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Correctie van onjuiste gegevens</li>
                <li>Aanvulling van onvolledige gegevens</li>
                <li>Update van verouderde informatie</li>
              </ul>

              <p>
                <strong>10.4</strong> <strong>Recht op Verwijdering (Artikel 17 GDPR)</strong><br />
                Ook bekend als "recht om vergeten te worden":
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Gegevens zijn niet langer nodig</li>
                <li>U trekt uw toestemming in</li>
                <li>U maakt bezwaar tegen verwerking</li>
                <li>Gegevens zijn onrechtmatig verwerkt</li>
                <li>Wettelijke verplichting tot verwijdering</li>
              </ul>

              <p>
                <strong>10.5</strong> <strong>Recht op Beperking (Artikel 18 GDPR)</strong><br />
                Tijdelijke stopzetting van verwerking wanneer:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>U de juistheid van gegevens betwist</li>
                <li>Verwerking onrechtmatig is</li>
                <li>Wij de gegevens niet meer nodig hebben</li>
                <li>U bezwaar heeft gemaakt</li>
              </ul>

              <p>
                <strong>10.6</strong> <strong>Recht op Overdraagbaarheid (Artikel 20 GDPR)</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Ontvang uw gegevens in gestructureerd formaat</li>
                <li>Machine-leesbaar formaat (JSON/CSV)</li>
                <li>Directe overdracht aan andere dienstverlener</li>
              </ul>

              <p>
                <strong>10.7</strong> <strong>Recht van Bezwaar (Artikel 21 GDPR)</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Bezwaar tegen verwerking voor direct marketing</li>
                <li>Bezwaar tegen profilering</li>
                <li>Bezwaar tegen verwerking op basis van gerechtvaardigd belang</li>
              </ul>

              <p>
                <strong>10.8</strong> <strong>Uitoefening van Rechten</strong><br />
                Om uw rechten uit te oefenen:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Stuur een e-mail naar privacy@ugc4you.nl</li>
                <li>Vermeld welk recht u wilt uitoefenen</li>
                <li>Voeg een kopie van uw ID bij (met BSN onleesbaar gemaakt)</li>
                <li>Wij reageren binnen 30 dagen</li>
                <li>Verzoeken zijn kosteloos (tenzij kennelijk ongegrond of buitensporig)</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">11. MINDERJARIGEN</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>11.1</strong> <strong>Leeftijdsbeperking</strong><br />
                Ons Platform is niet bedoeld voor personen jonger dan 18 jaar. Wij verzamelen niet bewust persoonlijke gegevens van minderjarigen.
              </p>

              <p>
                <strong>11.2</strong> <strong>Verificatie</strong><br />
                Bij registratie vragen wij gebruikers te bevestigen dat zij 18 jaar of ouder zijn. Wij kunnen aanvullende verificatie vragen bij twijfel.
              </p>

              <p>
                <strong>11.3</strong> <strong>Ontdekking van Minderjarige Gegevens</strong><br />
                Als wij ontdekken dat wij gegevens van een minderjarige hebben verzameld:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Verwijderen wij deze gegevens onmiddellijk</li>
                <li>Beëindigen wij het account</li>
                <li>Informeren wij indien mogelijk de ouders/voogden</li>
              </ul>

              <p>
                <strong>11.4</strong> <strong>Melding door Ouders</strong><br />
                Ouders die vermoeden dat hun kind zonder toestemming gegevens heeft verstrekt, kunnen contact opnemen via privacy@ugc4you.nl.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">12. WIJZIGINGEN AAN DEZE PRIVACY POLICY</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>12.1</strong> <strong>Updates en Wijzigingen</strong><br />
                Wij kunnen deze privacy policy van tijd tot tijd bijwerken om:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Nieuwe functies of diensten te reflecteren</li>
                <li>Wijzigingen in wetgeving na te leven</li>
                <li>Onze praktijken te verbeteren</li>
                <li>Feedback van gebruikers te verwerken</li>
              </ul>

              <p>
                <strong>12.2</strong> <strong>Notificatie van Wijzigingen</strong><br />
                Bij materiële wijzigingen zullen wij:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>U per e-mail informeren (voor geregistreerde gebruikers)</li>
                <li>Een prominente melding op het Platform plaatsen</li>
                <li>De "laatst bijgewerkt" datum aanpassen</li>
                <li>Waar nodig nieuwe toestemming vragen</li>
              </ul>

              <p>
                <strong>12.3</strong> <strong>Archief</strong><br />
                Vorige versies van onze privacy policy zijn op aanvraag beschikbaar via privacy@ugc4you.nl.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">13. CONTACT EN KLACHTEN</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>13.1</strong> <strong>Contact Informatie</strong>
              </p>
              <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-md">
                <p><strong>Bedrijfsnaam:</strong> UGC4you VOF</p>
                <p><strong>Website:</strong> https://ugc4you.nl</p>
                <p><strong>Privacy Officer:</strong> privacy@ugc4you.nl</p>
                <p><strong>Algemeen contact:</strong> info@ugc4you.nl</p>
                <p><strong>Telefoon:</strong> [Nog in te vullen]</p>
                <p><strong>Adres:</strong> [Nog in te vullen]</p>
                <p><strong>KvK-nummer:</strong> [Nog in te vullen]</p>
              </div>

              <p className="mt-4">
                <strong>13.2</strong> <strong>Response Tijden</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Privacy verzoeken: binnen 30 dagen (wettelijk vereist)</li>
                <li>Algemene vragen: binnen 48 uur</li>
                <li>Urgente privacy kwesties: binnen 24 uur</li>
              </ul>

              <p>
                <strong>13.3</strong> <strong>Klachtenprocedure</strong><br />
                Als u niet tevreden bent met hoe wij uw gegevens verwerken:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Neem eerst contact met ons op via privacy@ugc4you.nl</li>
                <li>Wij onderzoeken uw klacht grondig</li>
                <li>U ontvangt binnen 30 dagen een inhoudelijke reactie</li>
                <li>Wij streven naar een minnelijke oplossing</li>
              </ul>

              <p>
                <strong>13.4</strong> <strong>Toezichthoudende Autoriteit</strong><br />
                U heeft het recht een klacht in te dienen bij:
              </p>
              <div className="bg-white rounded-lg p-6 border border-gray-200 shadow-md">
                <p><strong>Autoriteit Persoonsgegevens</strong></p>
                <p>Postbus 93374</p>
                <p>2509 AJ Den Haag</p>
                <p>Telefoon: 0900-2001201</p>
                <p>Website: www.autoriteitpersoonsgegevens.nl</p>
              </div>

              <p className="mt-4">
                Wij raden echter aan eerst contact met ons op te nemen zodat wij samen naar een oplossing kunnen zoeken.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-[#0F172A]">14. AANVULLENDE INFORMATIE VOOR SPECIFIEKE REGIO'S</h2>

            <div className="space-y-4 text-[#0F172A]">
              <p>
                <strong>14.1</strong> <strong>Californië (CCPA/CPRA)</strong><br />
                Voor inwoners van Californië gelden aanvullende rechten onder de California Consumer Privacy Act:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Recht om te weten welke informatie verzameld wordt</li>
                <li>Recht om verwijdering te verzoeken</li>
                <li>Recht om opt-out voor verkoop van gegevens (wij verkopen geen gegevens)</li>
                <li>Recht op non-discriminatie</li>
              </ul>

              <p>
                <strong>14.2</strong> <strong>Verenigd Koninkrijk (UK GDPR)</strong><br />
                Voor UK inwoners gelden vergelijkbare rechten als EU GDPR, met ICO als toezichthouder.
              </p>

              <p>
                <strong>14.3</strong> <strong>Brazilië (LGPD)</strong><br />
                Voor Braziliaanse gebruikers gelden rechten onder de Lei Geral de Proteção de Dados.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <div className="bg-blue-50/60 rounded-lg p-6 border border-gray-200 shadow-md">
              <p className="text-sm text-[#475569]">
                <strong>Laatste update:</strong> 9 september 2025<br />
                <strong>Versie:</strong> 1.0<br />
                <strong>Van kracht per:</strong> 9 september 2025<br /><br />

                Deze Privacy Policy is opgesteld in overeenstemming met de Algemene Verordening Gegevensbescherming (GDPR), de Nederlandse Uitvoeringswet AVG, en andere toepasselijke privacy wetgeving. Wij zijn toegewijd aan het beschermen van uw privacy en het transparant communiceren over onze gegevensverwerkingspraktijken.

                <br /><br />
                Voor vragen over deze Privacy Policy of uw persoonlijke gegevens, neem contact op via <strong>privacy@ugc4you.nl</strong>.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPage